<template>
  <base-dialog class="condition-setting-dialog" :visible.sync="visible" @closed="$emit('closed')">
    <template #header>
      设置自定义条件
    </template>
    <condition-editor
      v-loading="loading"
      :sheet="decoratedSheet"
      :value="extraConditionList"
      type="条件"
      tip="满足条件才可操作"
      @update="conditionUpdate"
      @delete="conditionDelete"
    ></condition-editor>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/UIComponents/BaseDialog.vue"
import ConditionEditor from "../../Connect/ConditionEditor.vue"
import {
  addExtraPriLevel,
  deleteExtraPriLevel,
  getExtraPriLevelList,
  updateExtraPriLevel
} from "@/api/appManage/role"
import { decorateSheet } from "@/utils/sheet"
export default {
  name: "condition-setting-dialog",
  components: { BaseDialog, ConditionEditor },
  props: {},
  data() {
    return {
      visible: false,
      loading: false,
      sheet: null,
      extraConditionList: null
    }
  },
  computed: {
    decoratedSheet() {
      return decorateSheet(this.sheet)
    }
  },
  methods: {
    open({ sheet }) {
      this.visible = true
      Object.assign(this, { sheet })
      this.refreshConditionList()
    },
    refreshConditionList() {
      this.loading = true
      return getExtraPriLevelList(this.sheet.sheetId)
        .then(extraConditionList => (this.extraConditionList = extraConditionList))
        .finally(() => (this.loading = false))
    },
    async conditionUpdate(condition) {
      if (condition.id) {
        await updateExtraPriLevel(condition)
      } else {
        await addExtraPriLevel(Object.assign(condition, { sheetId: this.sheet.sheetId }))
      }
      await this.refreshConditionList()
    },
    async conditionDelete(condition) {
      await deleteExtraPriLevel(condition.id)
      await this.refreshConditionList()
    }
  }
}
</script>

<style lang="scss" scoped>
.condition-setting-dialog {
}
</style>
